<template>
  <div>
    <el-button type="primary" @click="openSee">
      <slot></slot>
    </el-button>

    <el-drawer
        title="出库操作"
        :visible.sync="openStatus"
        direction="rtl"
        size="90%"
        :append-to-body="true"
        :close-on-press-escape="false"
        :destroy-on-close="true"
        :wrapperClosable="false"
        :before-close="closeSee"
    >
      <div style="padding: 20px;">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form :inline="true">
              <el-form-item label="订单编号">
                <el-input v-model="query.order_code" placeholder="输入订单编号"></el-input>
              </el-form-item>

              <el-form-item>
                <el-button type="primary" @click="loadOrder">查询</el-button>
              </el-form-item>
            </el-form>

            <el-form v-if="order.id">
              <el-form-item label="选择产品">
                <el-select v-model="selectId" placeholder="选择订单内要出库的产品" style="width: 80%">
                  <el-option
                      v-for="(item, i) in productList"
                      :key="i"
                      :label="item.model_code + '('+ item.name +')'"
                      :value="item.product_id"
                  ></el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="出库信息">
                <el-input type="textarea" v-model="formOut" :rows="20"
                          placeholder='请输入出库信息，例如："13213123","3214234","..."'></el-input>
              </el-form-item>
              <div style="padding-bottom: 10px;font-size: 12px;color: #666666;">出库格式："13213123","3214234","..."
              </div>
              <el-form-item>
                <el-button type="primary" v-loading="submitIng" @click="toSubmit">提交</el-button>
              </el-form-item>
            </el-form>
          </el-col>
          <el-col :span="12">
            <el-collapse v-model="collapseIndex">
              <el-collapse-item :title="'出库成功条码：' + success.length" name="success">
                {{ success }}
              </el-collapse-item>
            </el-collapse>
            <el-collapse v-model="collapseIndex">
              <el-collapse-item :title="'出库成功箱码：' + success_box.length" name="success_box">
                {{ success }}
              </el-collapse-item>
            </el-collapse>
            <el-collapse v-model="collapseIndex">
              <el-collapse-item :title="'条码不是系统生成：' + fault_bar_code_not_build.length"
                                name="fault_bar_code_not_build">
                {{ success }}
              </el-collapse-item>
            </el-collapse>
            <el-collapse v-model="collapseIndex">
              <el-collapse-item :title="'条码未绑定：' + fault_bar_code_not_bind.length" name="fault_bar_code_not_bind">
                {{ success }}
              </el-collapse-item>
            </el-collapse>
            <el-collapse v-model="collapseIndex">
              <el-collapse-item :title="'条码未入库：' + fault_bar_code_not_inventory.length"
                                name="fault_bar_code_not_inventory">
                {{ success }}
              </el-collapse-item>
            </el-collapse>
            <el-collapse v-model="collapseIndex">
              <el-collapse-item :title="'箱码不是系统生成：' + fault_box_code_not_build.length"
                                name="fault_box_code_not_build">
                {{ success }}
              </el-collapse-item>
            </el-collapse>
            <el-collapse v-model="collapseIndex">
              <el-collapse-item :title="'箱码未生效：' + fault_box_code_not_bind.length" name="fault_box_code_not_bind">
                {{ success }}
              </el-collapse-item>
            </el-collapse>
            <el-collapse v-model="collapseIndex">
              <el-collapse-item :title="'箱码未绑定：' + fault_box_code_not_inventory.length"
                                name="fault_box_code_not_inventory">
                {{ success }}
              </el-collapse-item>
            </el-collapse>
            <el-collapse v-model="collapseIndex">
              <el-collapse-item :title="'箱码没数据：' + fault_box_code_not_data.length" name="fault_box_code_not_data">
                {{ success }}
              </el-collapse-item>
            </el-collapse>
          </el-col>
        </el-row>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import {mapState} from "vuex";

export default {
  components: {},
  data() {
    return {
      openStatus: false,
      query: {
        order_code: ''
      },
      formOut: '',
      form: {
        order_id: '',
        product_id: '',
        code: [],
      },
      selectId: '',
      order: {},
      productList: [],
      submitIng: false,
      success: [],
      success_box: [],
      fault_bar_code_not_build: [],
      fault_bar_code_not_bind: [],
      fault_bar_code_not_inventory: [],
      fault_box_code_not_build: [],
      fault_box_code_not_bind: [],
      fault_box_code_not_inventory: [],
      fault_box_code_not_data: [],
      collapseIndex: 'success'
    };
  },
  computed: mapState({
    config: (state) => state.config,
  }),
  props: {},
  mounted() {
  },
  methods: {
    loadOrder() {
      const _this = this;
      _this.order = {};
      _this.productList = [];
      _this.form.order_id = '';
      _this.form.product_id = '';
      _this.$api.wareOutOrder(_this.query)
          .then(res => {
            _this.order = res.order;
            _this.form.order_id = res.order.id;
            _this.productList = res.product;
          })
          .catch(err => {
            _this.$message.error(err.msg);
          })
    },
    openSee() {
      const _this = this;
      _this.form = {
        code: [],
      }
      _this.openStatus = true;
    },
    closeSee() {
      const _this = this;
      _this.form = {
        code: [],
      }
      _this.openStatus = false;
      _this.$emit('finish', {});
    },
    // 获取列表
    toSubmit() {
      const _this = this;
      _this.submitIng = true;
      if (_this.formOut !== '') {
        _this.form.code = _this.formOut.split(',');
      } else {
        _this.form.code = [];
      }
      _this.form.product_id = _this.selectId;
      _this.$api.wareOutSubmit(_this.form)
          .then(res => {
            _this.submitIng = false;
            _this.success = res.success;
            _this.success_box = res.success_box;
            _this.fault_bar_code_not_build = res.fault_bar_code_not_build;
            _this.fault_bar_code_not_bind = res.fault_bar_code_not_bind;
            _this.fault_bar_code_not_inventory = res.fault_bar_code_not_inventory;
            _this.fault_box_code_not_build = res.fault_box_code_not_build;
            _this.fault_box_code_not_bind = res.fault_box_code_not_bind;
            _this.fault_box_code_not_inventory = res.fault_box_code_not_inventory;
            _this.fault_box_code_not_data = res.fault_box_code_not_data;
            _this.$message.error('提交成功，请查看右边返回结果');
          })
          .catch(err => {
            _this.submitIng = false;
            _this.$message.error(err.msg);
          })
    },
  },
};
</script>